import React, { memo, useCallback, useEffect, useRef } from 'react';
import { RadioCircle } from '../../../../components/RadioCircle/RadioCircle';
import { PickUpPoint } from '../../../../models/pickupPoints.models';

import './PickUpElement.css';

type PickUpElementProps = {
  isSelected?: boolean;
  element: PickUpPoint;
  onElementSelect?: (pdr: PickUpPoint) => void;
};

export const PickUpElement: React.FC<PickUpElementProps> = memo(
  ({ isSelected, element, onElementSelect }) => {
    const optionRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
      if (isSelected) {
        optionRef.current?.scrollIntoView({ behavior: 'smooth' });
      }
    }, [isSelected]);

    const selectElement = useCallback(() => {
      onElementSelect?.(element);
    }, [element, onElementSelect]);

    return (
      <div
        onClick={selectElement}
        ref={optionRef}
        className="pick-up-element--element-container"
        role="option"
      >
        <RadioCircle isSelected={isSelected} />
        <div className="pick-up-element--element-description-container">
          <p className="pick-up-element--element-name">
            {element.name}{' '}
            <span className="pick-up-element--element-distance">
              {+element.distance * 1000} mt
            </span>
          </p>
          <p className="pick-up-element--element-description">
            {element.address}
          </p>
          <p className="pick-up-element--element-description">
            {element.telephone}
          </p>
        </div>
        <div className="pick-up-element--element-price">
          <p className="pick-up-element--price">
            {element.price && element.price.toFixed(2)}€
          </p>{' '}
          {element.originalPrice !== element.price && (
            <small className="pick-up-element--sale">
              {element?.originalPrice && element.originalPrice.toFixed(2)}€
            </small>
          )}
        </div>
      </div>
    );
  }
);
